module.exports = __webpack_public_path__ + "media/images/mobile-only/element07-706b3821ac911ddc3600d1466fbdf0d2.png";